import { getUserInitials, intoRGB } from '@shared/utils'
import { Avatar as AntAvatar, Flex } from 'antd'
import { AnyObject } from 'antd/es/_util/type'

import { ReactNode } from 'react'

import { Text } from '../Text'

import { useStyles } from './styles'

import type { FlexProps } from 'antd'

export type UserAvatarProps = {
  userData?: AnyObject
  fallback?: string
  extra?: ReactNode
} & Omit<FlexProps, 'children'>

export const UserAvatar = ({
  userData,
  fallback = '-',
  extra
}: UserAvatarProps) => {
  const { styles } = useStyles()

  const userName =
    userData?.name || `${userData?.first_name} ${userData?.last_name}`

  return (
    <div>
      {userName && userData ? (
        <Flex gap={4} align="center">
          <AntAvatar
            size={24}
            src={userData?.photo}
            style={{ backgroundColor: intoRGB(userName) }}
            className={styles.avatar}
          >
            <Flex align="center" justify="flex-end">
              <Text
                size={12}
                weight={600}
                className={styles.initials}
                style={{ color: intoRGB(userName) }}
              >
                {getUserInitials(userData)}
              </Text>
            </Flex>
          </AntAvatar>

          {userName && (
            <Text weight={600} isEllipsis>
              {userName}
            </Text>
          )}

          {extra}
        </Flex>
      ) : (
        fallback
      )}
    </div>
  )
}

UserAvatar.Group = AntAvatar.Group
